import a from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const r = {
  display: "block"
}, x = ({ size: e = 16, useVw: n, useRem: t, color: o, withColor: c, removeClassName: l, disableSSR: m, style: i, ...p }) => {
  const h = i ? { ...r, ...i } : r;
  return /* @__PURE__ */ a.createElement(f, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-lianshangzhuanbi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (t ? "rem" : "px"), height: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (t ? "rem" : "px"), className: l ? "" : "iconpark-icon", style: h, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: l ? "" : "32px-é¾ä¸èµå¸"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: l ? "" : "normal",
        fill: c ? d(o, 0, "#262933") : "#262933",
        datafollowfill: c ? d(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M16 3.3a3.678 3.678 0 1 0 0 7.356A3.678 3.678 0 0 0 16 3.3Zm-1.878 3.678a1.878 1.878 0 1 1 3.756 0 1.878 1.878 0 0 1-3.756 0Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M10.904 9.402a.9.9 0 1 0-.92-1.548l-3.27 1.943a3.678 3.678 0 0 0-1.8 3.162v2.352a.9.9 0 0 0 1.8 0V12.96c0-.663.35-1.276.92-1.615l3.27-1.942Zm11.111-1.548a.9.9 0 0 0-.92 1.548l3.271 1.942c.57.339.92.952.92 1.615v2.352a.9.9 0 0 0 1.8 0V12.96c0-1.298-.685-2.5-1.8-3.162l-3.27-1.943Zm.081 17.616a.9.9 0 0 0-.871-1.576l-4.316 2.386a1.878 1.878 0 0 1-1.818 0l-4.211-2.328a.9.9 0 1 0-.871 1.575l4.211 2.329a3.678 3.678 0 0 0 3.56 0l4.316-2.387Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M2.6 20.867a3.678 3.678 0 1 1 7.355 0 3.678 3.678 0 0 1-7.355 0Zm3.678-1.878a1.878 1.878 0 1 0 0 3.756 1.878 1.878 0 0 0 0-3.756Zm19.444-1.8a3.678 3.678 0 1 0 0 7.356 3.678 3.678 0 0 0 0-7.356Zm-1.878 3.678a1.878 1.878 0 1 1 3.756 0 1.878 1.878 0 0 1-3.756 0Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, E = x;
export {
  E as default
};
